import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { INodeOutput } from '@src/app/models/flow';

@Component({
    selector: 'app-flow-node-body-outputs',
    templateUrl: './flow-node-body-outputs.component.html',
    styleUrl: './flow-node-body-outputs.component.scss',
    standalone: false,
})
export class FlowNodeBodyOutputsComponent {
    public readonly removeConnection = output<string>();

    public readonly outputs = input.required<INodeOutput[]>();

    protected removeOutputConnection(outputId: string, event?: Event): void {
        event?.preventDefault();
        this.removeConnection.emit(outputId);
    }
}
